import Profissional from "../models/Profissional";

export default class RegistroFotografico {
  constructor() {
    this.numero = "";
    this.data = new Date();
    this.titulo = "RELATÓRIO PARA REGISTRO";
    this.subtitulo = "CHECKLIST FOTOGRÁFICO";
    this.quantidade = "6";
    this.cor = "#003c5a";
    this.fotoA = null;
    this.fotoB = null;
    this.fotoC = null;
    this.fotoD = null;
    this.fotoE = null;
    this.fotoF = null;
    this.inspetor = new Profissional();
  }

  update(ft) {
    this.numero = ft.numero;
    this.data = ft.data;
    this.titulo = ft.titulo;
    this.subtitulo = ft.subtitulo;
    this.quantidade = ft.quantidade;
    this.cor = ft.cor;
    this.fotoA = ft.fotoA;
    this.fotoB = ft.fotoB;
    this.fotoC = ft.fotoC;
    this.fotoD = ft.fotoD;
    this.fotoE = ft.fotoE;
    this.fotoF = ft.fotoF;
    this.inspetor = ft.inspetor;
  }
}
